import { BaseApiService } from "Apis/Service/BaseApiService";
import { IEnvConfigUtils } from "Interfaces/Utils/IEnvConfigUtils";
import { PagedResult } from "Models/Common/PagedResult";
import { TemplateFilter } from "Models/Filters/TemplateFilter";
import request from "../BaseRequest";

export class BaseTemplateController<T> extends BaseApiService {
    constructor(envConfigUtils: IEnvConfigUtils, uri: string) {
        super(envConfigUtils, uri);
    }

    public async getByFilterAsync(filter: TemplateFilter): Promise<PagedResult<T>> {
        this.init();

        const response = await request
            .get(this.endpoint)
            .query(filter)
            .set(this.headers);

        return response.body as PagedResult<T>;
    }

    public async getByIdAsync(templateId: number): Promise<T> {
        this.init();

        const response = await request
            .get(`${this.endpoint}/${templateId}`)
            .set(this.headers);

        return response.body as T;
    }
}


// WEBPACK FOOTER //
// ./src/Apis/Controllers/BaseTemplateController.ts